/* eslint-disable no-console */
import {Col, Form, Select} from 'antd';
import useFormInstance from 'antd/es/form/hooks/useFormInstance';
import React, {useState} from 'react';
import {useSearchParams} from 'react-router-dom';

import {ReactComponent as YearCalender} from '../../assets/yearCalender.svg';
import {CommonErrors, TF} from '../../constants/Common';
import {sortBy} from '../../shared/commonFunctions';
import {yearSelect} from '../../utils/FormUtils/yearSelect';
import FormListComp from '../DrawerForm/Utils/FormListComp';
import Loader from '../Loader/Loader';
import {MYConfig, MYData} from '../MonthlyYearly/Interface/common';
import MonthlyYearlyDrawerForm from '../MonthlyYearly/MonthlyYearlyDrawerForm';

import {yearKeyLabel} from './Constants/IP/commonKeyLabel';
import {B2bKey, B2bLabel} from './Constants/Products/B2BKeyLabel';
import {filterSelectOptions} from './Utils/commonFunctions';
import CapGoodsSupplierSpec from './Utils/TableListForm/CapGoodsSupplierSpec';

const B2bForm: React.FC<{
  data: any;
  setSubmitDisabled: React.Dispatch<React.SetStateAction<boolean>>;
  isAverage?: boolean;
  rawMaterialFilter: any;
  suppliers: any[];
  currentStep?: number;
  setFormSelectedYear: React.Dispatch<React.SetStateAction<string>>;
  setIsFormLoading: React.Dispatch<React.SetStateAction<boolean>>;
  isFormLoading: boolean;
}> = ({
  data,
  isAverage = true,
  rawMaterialFilter,
  suppliers,
  currentStep,
  setFormSelectedYear,
  setIsFormLoading,
  isFormLoading
}) => {
  const FormInstance = useFormInstance();
  const [searchParam] = useSearchParams();
  const {setFields, getFieldValue} = FormInstance;
  const {facilityFilter, productFilter} = rawMaterialFilter;

  const [selectedProduct, setSelectedProduct] = useState(
    productFilter?.find(
      (item: any) => item?.value === getFieldValue(B2bKey.PRODUCT_ID)
    ) ?? {}
  );

  const yearFilter = yearSelect();

  const monYear: MYConfig[] = [
    {
      mainTitle: {
        key: B2bKey.NO_UNIT_TF,
        title: B2bLabel.NO_UNIT_TF
      },
      unit: 'No.'
    }
  ];

  return (
    <>
      {isFormLoading ? (
        <Loader />
      ) : (
        <>
          {currentStep === 0 && (
            <>
              <Col className="gutter-row">
                <Form.Item
                  name={yearKeyLabel.key}
                  label={yearKeyLabel.label}
                  labelCol={{span: 24}}
                  initialValue={searchParam.get('selectedYear')}
                >
                  <Select
                    placeholder={yearKeyLabel.label}
                    options={yearFilter}
                    suffixIcon={<YearCalender />}
                    disabled={data?._id !== undefined}
                    onChange={(e) => {
                      setFormSelectedYear(e);
                      setIsFormLoading(true);
                      if (getFieldValue(B2bKey.PRODUCT_ID)) {
                        setFields([
                          {
                            name: B2bKey.PRODUCT_ID,
                            errors: [CommonErrors.selectAgain],
                            value: undefined
                          }
                        ]);
                      }
                      if (getFieldValue(B2bKey.FACILITY)) {
                        setFields([
                          {
                            name: B2bKey.FACILITY,
                            errors: [CommonErrors.selectAgain],
                            value: undefined
                          }
                        ]);
                      }
                      if (getFieldValue(B2bKey.RAW_MATERIAL)) {
                        setFields([
                          {
                            name: B2bKey.RAW_MATERIAL,
                            errors: [CommonErrors.selectAgain],
                            value: undefined
                          }
                        ]);
                      }
                      if (!isAverage && getFieldValue(B2bKey.ADD_SUPPLIER)) {
                        const updatedFormList = getFieldValue(
                          B2bKey.ADD_SUPPLIER
                        )?.map((item: any) => ({
                          ...item,
                          [B2bKey.SUPPLIER_ID]: undefined
                        }));
                        setFields([
                          {
                            name: B2bKey.ADD_SUPPLIER,
                            errors: [CommonErrors.selectAgain],
                            value: updatedFormList
                          }
                        ]);
                      }
                    }}
                  />
                </Form.Item>
              </Col>
              <Col className="gutter-row">
                <Form.Item
                  name={B2bKey.PRODUCT_ID}
                  rules={[
                    {
                      required: true,
                      message: CommonErrors.mandatory(B2bLabel.PRODUCT_ID)
                    }
                  ]}
                  label={B2bLabel.PRODUCT_ID}
                  labelCol={{span: 24}}
                >
                  <Select
                    className="select"
                    placeholder={B2bLabel.PRODUCT_ID}
                    options={sortBy(productFilter, 'label', 'asc')}
                    disabled={data?._id !== undefined}
                    onChange={(_, main) => {
                      setSelectedProduct(main);
                      if (getFieldValue(B2bKey.FACILITY)) {
                        setFields([
                          {
                            name: B2bKey.FACILITY,
                            errors: [CommonErrors.selectAgain],
                            value: undefined
                          }
                        ]);
                      }
                      if (!isAverage && getFieldValue(B2bKey.ADD_SUPPLIER)) {
                        setFields([
                          {
                            name: B2bKey.ADD_SUPPLIER,
                            errors: [CommonErrors.selectAgain],
                            value: [{[B2bKey.SUPPLIER_ID]: undefined}]
                          }
                        ]);
                      }
                    }}
                  />
                </Form.Item>
              </Col>
              <Col className="gutter-row">
                <Form.Item
                  name={B2bKey.FACILITY}
                  rules={[
                    {
                      required: true,
                      message: CommonErrors.mandatory(B2bLabel.FACILITY)
                    }
                  ]}
                  label={B2bLabel.FACILITY}
                  labelCol={{span: 24}}
                >
                  <Select
                    showSearch
                    filterOption={filterSelectOptions}
                    className="select"
                    placeholder={B2bLabel.FACILITY}
                    options={sortBy(
                      facilityFilter?.filter((item: any) => {
                        return data?._id
                          ? item?.[B2bKey.PRODUCT_ID] === data?.productId
                          : item?.[B2bKey.PRODUCT_ID] ===
                              getFieldValue(B2bKey.PRODUCT_ID);
                      }),
                      'label',
                      'asc'
                    )}
                    disabled={data?._id !== undefined}
                  />
                </Form.Item>
              </Col>
            </>
          )}
          {currentStep === 1 && (
            <>
              <MonthlyYearlyDrawerForm
                config={monYear}
                data={getFieldValue(TF) as MYData[]}
              />
            </>
          )}
          {currentStep === 0 && !isAverage && (
            <FormListComp
              mainName={B2bKey.ADD_SUPPLIER}
              formComponent={
                <CapGoodsSupplierSpec
                  supplier={suppliers.filter((item) => {
                    const dataProduct = data?._id
                      ? productFilter.find(
                          (item: any) => item.value === data?.productId
                        )?.value
                      : selectedProduct?.facilityId;

                    return item?.data.some((innerItem: any) => {
                      return data?._id
                        ? dataProduct
                        : innerItem?.goodsSupplied?.includes(
                            selectedProduct?.facilityId
                          );
                    });
                  })}
                />
              }
            />
          )}
        </>
      )}
    </>
  );
};

export default B2bForm;
